import mutations from './mutationBanner.js'
import actions from './actionBanner.js'

export default {
  state: {
    banners: {},
    banner: {}
  },
  mutations,
  actions
}
